__turbopack_context__.v({
  "isCompact": "topping-module__SKjnKW__isCompact",
  "toppings": "topping-module__SKjnKW__toppings",
});
